import { DiwaAPI } from './client'

/** Mirrors the sharing router — membership + invite links (Phase 16). */

export interface Member {
  id: string
  email: string | null
  role: string
  verdicts_shared: boolean
  joined_at: string | null
}

export interface OpenInvite {
  id: string
  role: string
  prefix: string
  created_at: string | null
}

export interface AcceptResult {
  domain_id: string
  slug: string
  name: string
  role: string
  already_member: boolean
}

/** What a link opens onto, read WITHOUT joining — shown before Accept/Decline. */
export interface InvitePreview {
  domain_id: string
  slug: string
  name: string
  role: string
  /** Email of whoever minted the link (usually the region owner); null if unknown. */
  invited_by: string | null
  /** The viewer is the region's owner — accepting is a no-op mistake. */
  is_own: boolean
  already_member: boolean
}

export class SharingAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  mintInvite(domainId: string, role: string): Promise<{ token: string; role: string; id: string }> {
    return this.api.post(`/domains/${domainId}/invites`, { role })
  }

  preview(token: string): Promise<InvitePreview> {
    return this.api.post('/invites/preview', { token })
  }

  accept(token: string): Promise<AcceptResult> {
    return this.api.post('/invites/accept', { token })
  }

  members(domainId: string): Promise<{ members: Member[]; invites: OpenInvite[] }> {
    return this.api.get(`/domains/${domainId}/members`)
  }

  removeMember(domainId: string, memberId: string): Promise<{ removed: boolean }> {
    return this.api.del(`/domains/${domainId}/members/${memberId}`)
  }

  revokeInvite(domainId: string, inviteId: string): Promise<{ revoked: boolean }> {
    return this.api.del(`/domains/${domainId}/invites/${inviteId}`)
  }

  writeEntity(domainId: string, body: { type: string; name: string }): Promise<{ applied?: boolean; proposed?: boolean; id?: string }> {
    return this.api.post(`/domains/${domainId}/region/entities`, body)
  }

  setPublished(domainId: string, published: boolean): Promise<{ published: boolean }> {
    return this.api.put(`/domains/${domainId}/publish`, { published })
  }
}
